// Restored from production OTA 2026-08-21 (module 1433).
import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, push, child, off } from "firebase/database";

export const fetchChatMessages = (bookingId) => (dispatch) => {
    const { chatRef } = firebase;

    dispatch({
        type: FETCH_MESSAGES,
        payload: bookingId,
    });
    onValue(chatRef(bookingId), (snapshot) => {
        if (snapshot.val()) {
            const rootEntry = snapshot.val();
            const allMesseges = [];
            for (let key in rootEntry) {
                const entryKey = rootEntry[key];
                for (let msgKey in entryKey) {
                    entryKey[msgKey].smsId = msgKey;
                    allMesseges.push(entryKey[msgKey]);
                }
            }
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: allMesseges,
            });
        } else {
            dispatch({
                type: FETCH_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    });
};

export const sendMessage = (data) => (dispatch) => {
    const { chatRef } = firebase;

    const chatId = data.booking.customer + ',' + data.booking.driver;
    const now = new Date();
    const time = now.getHours() + ":" + now.getMinutes();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = now.getFullYear();
    const today = mm + ':' + dd + ':' + yyyy;

    const msg = {
        message: data.message,
        from: data.role == 'customer' ? data.booking.customer : data.booking.driver,
        type: "msg",
        msgDate: today,
        msgTime: time,
        createdAt: new Date().toString(),
        source: data.role
    };

    push(child(chatRef(data.booking.id), chatId), msg);

    const lang = store.getState().languagedata.defaultLanguage;
    const notification = {
        title: lang.notification_title + lang.chat_requested,
        msg: data.message,
        screen: 'onlineChat',
        params: { bookingId: data.booking.id }
    };
    if (data.role == 'customer') {
        if (data.booking.driver_token) {
            RequestPushMsg(data.booking.driver_token, notification);
        }
    } else if (data.booking.customer_token) {
        RequestPushMsg(data.booking.customer_token, notification);
    }

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
};

export const stopFetchMessages = (bookingId) => (dispatch) => {
    const { chatRef } = firebase;

    dispatch({
        type: STOP_FETCH_MESSAGES,
        payload: bookingId,
    });
    off(chatRef(bookingId));
};
